import { cloneDeep } from 'lodash';
import { notificationModuleName as notificationModule } from '@jumpcloud/ui-notifications';
import TotpApi from 'client/MFA/totp/TotpApi';
import TotpMessages from 'client/MFA/totp/TotpMessages.json';
import Vue from 'vue';

export const INITIALIZE_STATE = 'INITIALIZE_STATE';
export const SET_STATE = 'SET_STATE';
export const SET_STARTING_STATE = 'SET_STARTING_STATE';
export const SET_ERROR_SAVING = 'SET_ERROR_SAVING';
export const SET_USER_PORTAL_TOTP_CONFIG = 'SET_USER_PORTAL_TOTP_CONFIG';

const initialState = () => ({
  userPortalTotpConfig: {
    enabled: true,
  },
  errorSaving: false,
});

export const createTotpSettingsModule = totpApi => ({
  namespaced: true,
  state: {
    ...initialState(),
    startingState: { ...initialState() },
  },
  mutations: {
    [INITIALIZE_STATE]: (state) => {
      const { userPortalTotpConfig, errorSaving } = initialState();
      Vue.set(state, 'userPortalTotpConfig', userPortalTotpConfig);
      Vue.set(state, 'errorSaving', errorSaving);
      Vue.set(state, 'startingState', initialState());
    },
    [SET_STATE]: (state) => {
      Vue.set(state, 'userPortalTotpConfig', cloneDeep(state.startingState.userPortalTotpConfig));
      Vue.set(state, 'errorSaving', initialState().errorSaving);
    },
    [SET_ERROR_SAVING]: (state, error = false) => {
      Vue.set(state, 'errorSaving', error);
    },
    [SET_STARTING_STATE]: (state) => {
      Vue.set(state.startingState, 'userPortalTotpConfig', cloneDeep(state.userPortalTotpConfig));
    },
    [SET_USER_PORTAL_TOTP_CONFIG]: (state, config = {}) => {
      Vue.set(state, 'userPortalTotpConfig', cloneDeep(config));
    },
  },
  getters: {
    enabledInUserPortal(state = {}) {
      return state.userPortalTotpConfig.enabled;
    },
    hasChanges(state = {}) {
      return state.userPortalTotpConfig.enabled
        !== state.startingState.userPortalTotpConfig.enabled;
    },
    hasErrors(state = {}) {
      return state.errorSaving;
    },
  },
  actions: {
    async changeUserPortalTotpConfig({ commit }, payload) {
      commit(SET_USER_PORTAL_TOTP_CONFIG, payload);
    },
    async initialize({ commit }) {
      try {
        commit(INITIALIZE_STATE);
        const result = await totpApi.getUserPortalTotpConfig();
        commit(SET_USER_PORTAL_TOTP_CONFIG, result);
        commit(SET_STARTING_STATE);
      } catch (err) {
        throw new Error(TotpMessages.getSettingsFailed);
      }
    },
    async resetState({ commit }) {
      commit(SET_STATE);
    },
    async saveChanges({ commit, dispatch, state }) {
      try {
        const result = await totpApi.saveUserPortalTotpConfig({ ...state.userPortalTotpConfig });
        commit(SET_USER_PORTAL_TOTP_CONFIG, result);
        commit(SET_ERROR_SAVING, false);
        commit(SET_STARTING_STATE);
        const status = state.userPortalTotpConfig.enabled ? 'enabled' : 'disabled';
        dispatch(`${notificationModule}/triggerSuccessNotification`, {
          title: `TOTP has been ${status}.`,
        }, { root: true });
      } catch (error) {
        commit(SET_ERROR_SAVING, true);
        dispatch(`${notificationModule}/triggerErrorNotification`, {
          title: TotpMessages.saveFailed,
        }, { root: true });
        throw new Error(TotpMessages.saveFailed);
      }
    },
  },
});

export default createTotpSettingsModule(TotpApi);
